// UI and service messages for the Admin Area. User-entered identifiers are not translated.
export const adminTranslations = {
  "Checking the previous activation …":
    "Die vorherige Aktivierung wird geprüft …",
  Overview: "Übersicht",
  Statistics: "Statistiken",
  Appearance: "Erscheinungsbild",
  "Catalog & Registry": "Katalog & Registry",
  Administrators: "Administratoren",
  "Sign-in": "Anmeldung",
  Operations: "Betrieb",
  "Change history": "Änderungsverlauf",
  On: "An",
  Off: "Aus",
  "Grant reference": "Förderkennzeichen",
  "Project name": "Projektname",
  "Project logo": "Projektlogo",
  "Login providers": "Login-Anbieter",
  "Funding logos": "Förderlogos",
  Close: "Schließen",
  "Previous state loaded as a draft. Review the changes before saving.":
    "Vorheriger Stand als Entwurf geladen. Bitte Änderungen prüfen.",
  "Checking administration permissions …":
    "Admin-Berechtigungen werden geprüft …",
  "No Admin Area is available for this Solid WebID.":
    "Für diese Solid-WebID ist keine Admin Area freigegeben.",
  "Visible in menu": "Im Menü sichtbar",
  Active: "Aktiv",
  Disabled: "Deaktiviert",
  "Statistics collection": "Statistikerfassung",
  "User activity, downloads, user survey and metadata quality.":
    "Nutzeraktivität, Downloads, Nutzerbefragung und Metadatenqualität.",
  "Open statistics": "Statistiken öffnen",
  "Availability and menu entries for this profile.":
    "Verfügbarkeit und Menüeinträge für dieses Profil.",
  Application: "Anwendung",
  "In menu": "Im Menü",
  "Active controls availability through this profile. In menu controls only the sidebar entry. Pod permissions still apply.":
    "„Aktiv“ steuert die Erreichbarkeit über dieses Profil. „Im Menü“ steuert nur den Sidebar-Eintrag. Pod-Zugriffsrechte bleiben maßgeblich.",
  "Project name, logos and funding acknowledgements.":
    "Projektname, Logos und Förderhinweise.",
  "Project & logo": "Projekt & Logo",
  "Logo URL or path": "Logo-URL oder Pfad",
  "Existing file or HTTPS address.": "Vorhandene Datei oder HTTPS-Adresse.",
  "Alternative text": "Alternativtext",
  "Logo width": "Logobreite",
  "For example 95px.": "Zum Beispiel 95px.",
  "Logo height": "Logohöhe",
  "For example auto.": "Zum Beispiel auto.",
  Preview: "Vorschau",
  "Funding acknowledgements": "Förderhinweise",
  "Add logo": "Logo hinzufügen",
  Identifier: "Kennung",
  "Logo address": "Logo-Adresse",
  Description: "Beschreibung",
  Order: "Reihenfolge",
  Width: "Breite",
  Height: "Höhe",
  "Maximum height": "Maximale Höhe",
  "Remove logo": "Logo entfernen",
  "The registry is determined by the profile being accessed.":
    "Die Registry ergibt sich aus dem aufgerufenen Profil.",
  "Assigned registry": "Zugeordnete Registry",
  "The catalog shows accessible data sources from registered people, without a registry filter or registry information row.":
    "Angezeigt werden die erreichbaren Datenquellen der registrierten Personen. Im Katalog erscheinen weder Registry-Filter noch Registry-Infozeile.",
  "Cache & search": "Cache & Suche",
  "Cache and search indexes remain separate for each registry. Assignment changes are checked with the responsible services.":
    "Cache und Suchindex bleiben pro Registry getrennt. Änderungen der Zuordnung werden mit den zuständigen Diensten geprüft.",
  "Existing data": "Bestehende Daten",
  "This administration does not modify catalog entries or Pod permissions. Existing DACE data is retained.":
    "Diese Verwaltung verändert keine Katalogeinträge oder Berechtigungen in den Pods. Der DACE-Altbestand bleibt erhalten.",
  "Multiple Solid WebIDs can manage this profile.":
    "Mehrere Solid-WebIDs können dieses Profil verwalten.",
  "Add administrator": "Admin hinzufügen",
  "Your WebID": "Deine WebID",
  "Profile administrator": "Profil-Admin",
  Remove: "Entfernen",
  "The server checks the signed-in WebID. Your own permission and at least one administrator are retained.":
    "Die Berechtigung wird auf dem Server anhand der angemeldeten WebID geprüft. Die eigene Berechtigung und mindestens ein Admin bleiben erhalten.",
  "Statistics access": "Statistik-Zugriff",
  "Authorized WebIDs, one per line": "Berechtigte WebIDs · eine pro Zeile",
  "Statistics read access and profile administration are assigned separately. The statistics Pod must also permit access.":
    "Statistik-Leserechte und Profil-Verwaltung werden getrennt vergeben. Der Statistik-Pod muss den Zugriff ebenfalls erlauben.",
  "Solid providers for this profile.": "Solid-Anbieter für dieses Profil.",
  "New provider": "Neuer Anbieter",
  "Add provider": "Anbieter hinzufügen",
  "Display name": "Anzeigename",
  "Issuer address": "Issuer-Adresse",
  Note: "Hinweis",
  Recommended: "Empfohlen",
  "The existing Statistics Dashboard is integrated here.":
    "Das bestehende Statistics Dashboard ist hier integriert.",
  "No statistics read access is configured for this WebID.":
    "Für diese WebID sind keine Statistik-Leserechte konfiguriert.",
  "Statistics collection is disabled in this profile. The existing settings have been retained.":
    "Die Statistikerfassung ist in diesem Profil deaktiviert. Die bestehenden Einstellungen wurden übernommen.",
  "Existing reports: the configured statistics store may cover multiple profiles. Only explicitly authorized statistics administrators have access.":
    "Bestandsauswertung: Der konfigurierte Statistik-Speicher kann mehrere Profile umfassen. Zugriff erhalten ausschließlich die dafür berechtigten Statistik-Admins.",
  "Statistics settings": "Statistik-Einstellungen",
  "Enable statistics collection": "Statistikerfassung aktiv",
  "Statistics Pod": "Statistik-Pod",
  "Download events": "Download-Ereignisse",
  "Worker WebID": "Worker-WebID",
  Timezone: "Zeitzone",
  "Activity resource path": "Aktivitäts-Ressourcenpfad",
  "Live Test does not collect production statistics.":
    "Der Live-Test erfasst keine produktiven Statistikdaten.",
  "Existing operational parameters for this profile.":
    "Bestehende Betriebsparameter dieses Profils.",
  "Worker administration in the interface":
    "Worker-Verwaltung in der Oberfläche",
  "API address": "API-Adresse",
  "Service WebID": "Service-WebID",
  "Default sync interval (minutes)": "Vorgabe für Sync-Intervall (Minuten)",
  "Interface default; the actual worker schedule is configured separately.":
    "Vorgabe der Oberfläche; der tatsächliche Worker-Takt wird gesondert konfiguriert.",
  Workspaces: "Arbeitsbereiche",
  "PLASMA address": "PLASMA-Adresse",
  "Node-RED and PLASMA retain their separate workspaces. Services and data volumes are not deleted or merged here.":
    "Node-RED und PLASMA behalten ihre getrennten Arbeitsbereiche. Dienste und Datenvolumes werden hier nicht gelöscht oder zusammengeführt.",
  "Additional domains need matching DNS, routing and login settings.":
    "Zusätzliche Domains benötigen passende DNS-, Routing- und Login-Einstellungen.",
  "City Tours · existing permissions": "City Tours · bestehende Freigaben",
  "WebIDs, one per line": "WebIDs · eine pro Zeile",
  "Saved changes": "Gespeicherte Änderungen",
  "No changes have been saved through the Admin Area yet.":
    "Noch keine Änderungen über die Admin Area gespeichert.",
  Applied: "Übernommen",
  "Pending server change": "Betriebsänderung offen",
  Failed: "Fehlgeschlagen",
  "Rolled back": "Zurückgesetzt",
  "In progress": "In Bearbeitung",
  "Load previous state as a draft": "Vorherigen Stand als Entwurf laden",
  "You are managing profile": "Du verwaltest das Profil",
  "Select profile": "Profil auswählen",
  "Live Test": "Live-Test",
  Production: "Produktion",
  "Administration sections": "Admin-Bereiche",
  Section: "Bereich",
  "Load current state": "Aktuellen Stand laden",
  "Reload interface": "Oberfläche neu laden",
  "Loading configuration …": "Konfiguration wird geladen …",
  "Unsaved changes": "Ungespeicherte Änderungen",
  "No pending changes": "Keine offenen Änderungen",
  Discard: "Verwerfen",
  "Checking …": "Wird geprüft …",
  "Review changes": "Änderungen prüfen",
  "Saving …": "Wird gespeichert …",
  Apply: "Übernehmen",
  "Profile:": "Profil:",
  "The previous state is backed up. Settings are then applied without a new app release.":
    "Der vorherige Stand wird gesichert. Anschließend werden die Einstellungen ohne neues App-Release übernommen.",
  "Edit application": "Anwendung bearbeiten",
  "Menu group": "Menügruppe",
  "Use data": "Daten nutzen",
  "Icon key": "Symbolkennung",
  "Link type": "Linkart",
  Internal: "Intern",
  External: "Extern",
  "Add to draft": "Vormerken",
  "Full Solid WebID": "Vollständige Solid-WebID",
  "This person may manage this profile's settings. Statistics access and Pod access are assigned separately.":
    "Diese Person darf die Einstellungen dieses Profils verwalten. Statistik-Leserechte und Pod-Zugriffe werden separat vergeben.",
  "Switch profile?": "Profil wechseln?",
  "Discard and switch": "Verwerfen und wechseln",
  "Unsaved changes to this profile would be discarded.":
    "Die ungespeicherten Änderungen dieses Profils würden verworfen.",
  "Settings for": "Einstellungen für",
  active: "aktiv",
  "in menu": "im Menü",
  edit: "bearbeiten",
  "Changes are checked, backed up and activated. Shared server changes require operator access; affected services are verified after the update.":
    "Änderungen werden geprüft, gesichert und aktiviert. Gemeinsame Serveränderungen benötigen Betreiberrechte; betroffene Dienste werden anschließend geprüft.",
  "Existing Pod permissions remain unchanged. Configuration changes are checked before activation.":
    "Bestehende Pod-Berechtigungen bleiben erhalten. Konfigurationsänderungen werden vor der Aktivierung geprüft.",
  "Changes, backups and activation results.":
    "Änderungen, Sicherungen und Ergebnisse der Aktivierung.",
  Discarded: "Verworfen",
  "Activate and check services": "Aktivieren und Dienste prüfen",
  "The previous state is backed up. Affected services are updated and checked; failures trigger a rollback.":
    "Der vorherige Stand wird gesichert. Betroffene Dienste werden aktualisiert und geprüft; bei Fehlern wird der vorherige Stand wiederhergestellt.",
  "Load saved proposal": "Vorgemerkte Änderung laden",
  "Discard proposal": "Vorgemerkte Änderung verwerfen",
  "Saved proposal loaded. Review it again before activation.":
    "Vorgemerkte Änderung geladen. Bitte vor der Aktivierung erneut prüfen.",
  "Create profile": "Profil anlegen",
  "Copy settings from": "Einstellungen übernehmen von",
  "Profile identifier": "Profilkennung",
  "Domains, one per line; primary address first":
    "Domains · eine pro Zeile, Hauptadresse zuerst",
  "Registry URL": "Registry-Adresse",
  "Administrators, one WebID per line":
    "Administratoren · eine WebID pro Zeile",
  "Use an existing, publicly readable registry. Creating or changing Pod resources requires the owner's permission and is not performed here.":
    "Verwende eine bestehende, öffentlich lesbare Registry. Das Anlegen oder Ändern von Pod-Ressourcen benötigt die Berechtigung des Eigentümers und erfolgt hier nicht.",
  "Create a separate Node-RED workspace":
    "Eigenen Node-RED-Arbeitsbereich anlegen",
  "Create a separate PLASMA workspace": "Eigenen PLASMA-Arbeitsbereich anlegen",
  "New workspaces start with empty data volumes. Existing user data is never copied. DNS must point to this server.":
    "Neue Arbeitsbereiche starten mit leeren Datenbereichen. Bestehende Nutzerdaten werden nicht kopiert. DNS muss auf diesen Server zeigen.",
  "Checks passed. The profile will be created in this environment with the settings shown above.":
    "Prüfung erfolgreich. Das Profil wird mit den oben angezeigten Einstellungen in dieser Umgebung angelegt.",
  "Checking and activating …": "Wird geprüft und aktiviert …",
  "Create and activate profile": "Profil anlegen und aktivieren",
  "Check new profile": "Neues Profil prüfen",
  "Profile created and activated.": "Profil angelegt und aktiviert.",
  "Worker scheduler interval (seconds)": "Worker-Prüfintervall (Sekunden)",
  "Catalog cache refresh (seconds)": "Katalog-Cache aktualisieren (Sekunden)",
  "Monitoring cache refresh (seconds)":
    "Monitoring-Cache aktualisieren (Sekunden)",
  "Search index refresh (seconds)": "Suchindex aktualisieren (Sekunden)",
  "Shared server settings": "Gemeinsame Servereinstellungen",
  Operator: "Betreiber",
  "These intervals apply to all profiles in this environment. Only affected services are updated. Test remains a read-only cache preview.":
    "Diese Intervalle gelten für alle Profile dieser Umgebung. Nur betroffene Dienste werden aktualisiert. Test bleibt eine lesende Cache-Vorschau.",
  "Activate server settings": "Servereinstellungen aktivieren",
  "Review server settings": "Servereinstellungen prüfen",
  "Redirect aliases to the primary address, one per line":
    "Auf die Hauptadresse weiterleiten · eine Alias-Adresse pro Zeile",
  "Keep the address currently in use as an alias. Open the new address before redirecting the old one.":
    "Behalte die gerade verwendete Adresse als Alias. Öffne die neue Adresse, bevor du die alte weiterleitest.",
  "The update failed. Check the change history.":
    "Die Aktualisierung ist fehlgeschlagen. Prüfe den Änderungsverlauf.",
  "The update is still running. Its status is available in the change history.":
    "Die Aktualisierung läuft noch. Ihr Status ist im Änderungsverlauf verfügbar.",
  "Interrupted deployment was restored.":
    "Die unterbrochene Aktualisierung wurde zurückgesetzt.",
  "Invalid profile configuration.": "Ungültige Profil-Konfiguration.",
  "Invalid domains.": "Ungültige Domains.",
  "Redirects must be additional domains of this profile.":
    "Weiterleitungen müssen zusätzliche Domains dieses Profils sein.",
  "The profile identifier cannot be changed.":
    "Die Profilkennung ist unveränderlich.",
  "Existing setting sections must be retained.":
    "Bestehende Einstellungsbereiche müssen erhalten bleiben.",
  "All known apps must be present exactly once.":
    "Alle bekannten Apps müssen genau einmal vorhanden sein.",
  "Invalid menu group or link type.": "Ungültige Menügruppe oder Linkart.",
  "Internal app links must start with /.":
    "Interne App-Links müssen mit / beginnen.",
  "Order must be between 0 and 10000.":
    "Reihenfolge muss zwischen 0 und 10000 liegen.",
  "The active Admin Area cannot disable itself.":
    "Die aktive Admin Area darf sich nicht selbst deaktivieren.",
  "Too many funding logos.": "Zu viele Förderlogos.",
  "Duplicate logo identifier.": "Doppelte Logo-ID.",
  "Invalid funding logo order.": "Ungültige Reihenfolge der Förderlogos.",
  "At least one login provider is required.":
    "Mindestens ein Login-Anbieter ist erforderlich.",
  "Duplicate provider identifier.": "Doppelte Anbieter-ID.",
  "Enable at least one provider and recommend at most one.":
    "Mindestens einen Anbieter aktivieren und höchstens einen empfehlen.",
  "At least one existing login provider must remain enabled.":
    "Mindestens ein bestehender Login-Anbieter muss aktiv bleiben.",
  "Unknown registry.": "Unbekannte Registry.",
  "The sync interval must be between 1 and 1440 minutes.":
    "Sync-Intervall muss zwischen 1 und 1440 Minuten liegen.",
  "Invalid timezone.": "Ungültige Zeitzone.",
  "Invalid statistics resource path.": "Ungültiger Statistik-Ressourcenpfad.",
  "Live Test remains without production statistics collection and worker administration.":
    "Live-Test bleibt ohne produktive Statistikerfassung und Worker-Verwaltung.",
  "This profile cannot be administered in this instance.":
    "Dieses Profil ist auf dieser Instanz nicht zur Verwaltung freigegeben.",
  "Profile not found.": "Profil nicht gefunden.",
  "You do not have permission for this profile.":
    "Keine Berechtigung für dieses Profil.",
  "The profile changed in the meantime. Reload it first.":
    "Das Profil wurde zwischenzeitlich geändert. Bitte neu laden.",
  "A domain is already assigned to another profile.":
    "Eine Domain ist bereits einem anderen Profil zugeordnet.",
  "You cannot remove your own administrator permission in this session.":
    "Die eigene Admin-Berechtigung kann in dieser Sitzung nicht entfernt werden.",
  "No changes to apply.": "Keine Änderungen vorhanden.",
  "Invalid change preview.": "Ungültige Änderungsvorschau.",
  "The change preview has expired or was already applied.":
    "Änderungsvorschau abgelaufen oder bereits übernommen.",
  "You do not have permission for this change preview.":
    "Keine Berechtigung für diese Änderungsvorschau.",
  "The change preview has expired. Review the changes again.":
    "Änderungsvorschau abgelaufen. Bitte erneut prüfen.",
  "The YAML file changed during validation. Reload it first.":
    "Die YAML-Datei wurde während der Prüfung geändert. Bitte neu laden.",
  "The change could not be applied; the previous state is retained.":
    "Die Änderung konnte nicht übernommen werden; der vorherige Stand bleibt erhalten.",
  "Configuration backed up and applied.":
    "Konfiguration gesichert und übernommen.",
  "Invalid revision.": "Ungültige Revision.",
  "Revision not found.": "Revision nicht gefunden.",
  "Access denied.": "Kein Zugriff.",
  "This change requires operator permission.":
    "Diese Änderung erfordert Betreiberrechte.",
  "The profile identifier needs 2 to 40 lowercase letters, digits or hyphens.":
    "Die Profilkennung benötigt 2 bis 40 Kleinbuchstaben, Ziffern oder Bindestriche.",
  "This profile identifier is already in use.":
    "Diese Profilkennung ist bereits vergeben.",
  "The maximum number of profiles has been reached.":
    "Die maximale Anzahl von Profilen ist erreicht.",
  "Invalid registry address.": "Ungültige Registry-Adresse.",
  "The registry identifier is already in use.":
    "Die Registry-Kennung ist bereits vergeben.",
  "The registry changed in the meantime. Review the changes again.":
    "Die Registry wurde zwischenzeitlich geändert. Bitte erneut prüfen.",
  "The configuration changed in the meantime. Review the changes again.":
    "Die Konfiguration wurde zwischenzeitlich geändert. Bitte erneut prüfen.",
  "The profile could not be activated. The previous state was restored.":
    "Das Profil konnte nicht aktiviert werden. Der vorherige Stand wurde wiederhergestellt.",
  "This change cannot be discarded.":
    "Diese Änderung kann nicht verworfen werden.",
  "Saved change discarded.": "Vorgemerkte Änderung verworfen.",
  "The server settings changed in the meantime.":
    "Die Servereinstellungen wurden zwischenzeitlich geändert.",
  "Invalid server settings.": "Ungültige Servereinstellungen.",
  "An interval is outside the allowed range.":
    "Ein Intervall liegt außerhalb des zulässigen Bereichs.",
  "The server settings could not be activated.":
    "Die Servereinstellungen konnten nicht aktiviert werden.",
  "Server settings applied and services checked.":
    "Servereinstellungen übernommen und Dienste geprüft.",
  "The address currently in use must remain an alias. Open the new address first to remove or redirect the old one.":
    "Die gerade verwendete Adresse muss als Alias erhalten bleiben. Öffne zuerst die neue Adresse, um die alte zu entfernen oder weiterzuleiten.",
  "Another update is running. Please wait.":
    "Eine Aktualisierung läuft bereits. Bitte kurz warten.",
  "Invalid job.": "Ungültiger Auftrag.",
  "Job not found.": "Auftrag nicht gefunden.",
  "Permission denied.": "Keine Berechtigung.",
  "Unknown workspace template.": "Unbekannte Arbeitsbereich-Vorlage.",
  "The service could not be updated. The previous configuration is being restored.":
    "Der Dienst konnte nicht aktualisiert werden. Die vorherige Konfiguration wird wiederhergestellt.",
  "Connection checks are currently unavailable.":
    "Die Verbindungsprüfung ist derzeit nicht erreichbar.",
  "You do not have permission for this environment.":
    "Keine Berechtigung für diese Umgebung.",
  "The active configuration differs from the YAML files. Reconcile them first.":
    "Die aktive Konfiguration weicht von den YAML-Dateien ab. Bitte zuerst abgleichen.",
  "This change would affect production profiles.":
    "Diese Änderung würde produktive Profile verändern.",
  "The address must resolve to a public server.":
    "Die Adresse muss auf einen öffentlichen Server zeigen.",
  "A complete HTTPS address is required.":
    "Eine vollständige HTTPS-Adresse ist erforderlich.",
  "Response too large.": "Die Antwort ist zu groß.",
  "The connection timed out.":
    "Die Zeit für die Verbindungsprüfung ist abgelaufen.",
  "The login provider does not publish valid issuer metadata.":
    "Der Login-Anbieter veröffentlicht keine gültigen Issuer-Metadaten.",
  "Login endpoints must use HTTPS on the issuer host.":
    "Login-Endpunkte müssen HTTPS auf dem Host des Anbieters verwenden.",
  "The login provider has no verification keys.":
    "Der Login-Anbieter hat keine Prüfschlüssel.",
  "The registry must be an accessible RDF resource.":
    "Die Registry muss eine erreichbare RDF-Ressource sein.",
  "The new address does not serve the expected profile.":
    "Die neue Adresse liefert nicht das erwartete Profil aus.",
  "Invalid request size.": "Ungültige Anfragegröße.",
  "Invalid configuration or request.": "Ungültige Konfiguration oder Anfrage.",
  "The configuration could not be processed.":
    "Die Konfiguration konnte nicht verarbeitet werden.",
  "Unknown operation.": "Unbekannter Aufruf.",
  "Request too large.": "Anfrage zu groß.",
  "Invalid request.": "Ungültige Anfrage.",
  "Unknown administration host.": "Unbekannter Verwaltungs-Host.",
  "Foreign origin is not allowed.": "Fremder Ursprung nicht erlaubt.",
  "Invalid update request.": "Ungültiger Änderungsaufruf.",
  "Too many requests. Please wait.": "Zu viele Anfragen. Bitte kurz warten.",
  "Sign in with an authorized Solid WebID.":
    "Bitte mit einer berechtigten Solid-WebID anmelden.",
  "Not found.": "Nicht gefunden.",
  "Method not allowed.": "Methode nicht erlaubt.",
  "The administration service is currently unavailable.":
    "Verwaltungsdienst derzeit nicht erreichbar.",
  "The administration service is not reachable.":
    "Der Verwaltungsdienst ist nicht erreichbar.",
  "Maximum logo height": "Maximale Logohöhe",
  "Profile administrators": "Profil-Administratoren",
  "Statistics read access": "Statistik-Leserechte",
  "Registry assignment": "Registry-Zuordnung",
  Activation: "Aktivierung",
  "Authorized WebIDs": "Berechtigte WebIDs",
  "Default interval": "Intervall-Vorgabe",
};

export function translateAdminDynamic(value, language) {
  const pairs = [
    [
      /^DNS does not point to this server: (.+)$/,
      (m) => `DNS zeigt nicht auf diesen Server: ${m[1]}`,
    ],
    [
      /^The configured address is not reachable \(HTTP (\d+)\)\.$/,
      (m) => `Die konfigurierte Adresse ist nicht erreichbar (HTTP ${m[1]}).`,
    ],
  ];
  if (language === "de") {
    for (const [pattern, format] of pairs) {
      const m = value.match(pattern);
      if (m) return format(m);
    }
  }
  if (language === "en") {
    const labels = Object.fromEntries(
      Object.entries(adminTranslations).map(([en, de]) => [de, en]),
    );
    const patterns = [
      [
        /^Ungültiger Wert: (.+)\.$/,
        (m) => `Invalid value: ${labels[m[1]] || m[1]}.`,
      ],
      [
        /^Unbekannte Felder: (.+)\.$/,
        (m) => `Unknown fields: ${labels[m[1]] || m[1]}.`,
      ],
      [
        /^(.+) muss an oder aus sein\.$/,
        (m) => `${labels[m[1]] || m[1]} must be on or off.`,
      ],
      [
        /^(.+) kann hier nicht geändert werden\.$/,
        (m) => `${m[1]} cannot be changed here.`,
      ],
      [
        /^(.+): vollständige HTTPS-Adresse oder zulässiger lokaler Pfad erforderlich\.$/,
        (m) =>
          `${labels[m[1]] || m[1]}: a complete HTTPS address or valid local path is required.`,
      ],
      [
        /^(.+): eindeutige WebIDs erforderlich \(mindestens (\d+)\)\.$/,
        (m) =>
          `${labels[m[1]] || m[1]}: distinct WebIDs are required (at least ${m[2]}).`,
      ],
      [
        /^(.+): dieser Identitätsanbieter ist für die Administration nicht freigegeben\.$/,
        (m) =>
          `${labels[m[1]] || m[1]}: this identity host is not authorized for administration.`,
      ],
      [
        /^(.+): z\. B\. 95px oder auto verwenden\.$/,
        (m) => `${m[1]}: use a value such as 95px or auto.`,
      ],
    ];
    for (const [pattern, format] of patterns) {
      const match = value.match(pattern);
      if (match) return format(match);
    }
  }
  return "";
}
